import { FC, memo } from 'react';

import { FileIconState, IDefaultFileIconProps } from '../FileIcon.types';
import { getFileIconComponent } from '../FileIcon.utils';

export const FileIconDefault: FC<IDefaultFileIconProps> = memo((props) => {
  const { state = FileIconState.Regular, text, theme, onCancel } = props;

  const maxTextLength = 4;
  const handledText = text.length > maxTextLength ? `${text.substring(0, 3)}...` : text;

  const commonProps = { theme, text: handledText, onCancel };
  const Component = getFileIconComponent(props.type, state);

  return <Component {...commonProps} />;
});
